export default __webpack_public_path__ + "static/media/25.03c450d5.jpg";